/* eslint-disable react/jsx-props-no-spreading */
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import CategoryFilters from "./category-chip";
import { BlogCard } from "./control-card";
import PageContainer from "../page-container/page-container";
import useIsFlagEnabled from "../launchdarkly/use-is-flag-enabled";
import { categories, items } from "./constants";

const Control = () => {
  const navigate = useNavigate();
  const isFlagEnabled = useIsFlagEnabled();
  const [selectedCategory, setSelectedCategory] = useState<string>(
    categories[0],
  );

  const handleOnCardClick = (href: string | undefined) => {
    if (href) {
      navigate(href);
    }
  };

  const handleOnChipClick = (category: string) => {
    setSelectedCategory(category);
  };

  return (
    <PageContainer
      title="Control Panel"
      actions={
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 4 }}>
          <CategoryFilters
            categories={categories}
            onChipClick={handleOnChipClick}
          />
        </Box>
      }
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 8,
          minHeight: "400px",
        }}
      >
        <Grid container spacing={2}>
          {items
            .filter((card) =>
              selectedCategory === "All categories"
                ? true
                : card.tag === selectedCategory,
            )
            .map((card) =>
              isFlagEnabled(card.flag) ? (
                <Grid
                  key={card.title}
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <BlogCard {...card} onCardClick={handleOnCardClick} />
                </Grid>
              ) : null,
            )}
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default Control;
